import { useQuery } from '@tanstack/react-query';
import { Swords, Trophy, XCircle } from 'lucide-react';
import { api } from '@/lib/api';
import { cn } from '@/lib/utils';
import { KIND_LABEL } from '@/lib/vsSeverity';

export default function VsWeekChip({
  variant = 'dashboard',
}: {
  variant?: 'dashboard' | 'public';
}) {
  const query = useQuery({
    queryKey: ['vs-current'],
    queryFn: api.getCurrentVs,
    staleTime: 60_000,
  });
  const data = query.data;
  if (!data) return null;

  const kindStyles =
    data.kind === 'push'
      ? 'bg-indigo-900/40 border-indigo-700 text-indigo-100'
      : data.kind === 'aborted_push'
        ? 'bg-rose-900/30 border-rose-700 text-rose-100'
        : data.kind === 'soft_push'
          ? 'bg-amber-900/30 border-amber-700 text-amber-100'
          : 'bg-slate-800/60 border-slate-700 text-slate-200';

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-lg border px-3 py-1.5 text-sm',
        kindStyles,
        variant === 'public' && 'text-sm',
      )}
    >
      <Swords size={16} className="opacity-80" />
      <span className="font-medium">{KIND_LABEL[data.kind]}</span>
      <span className="text-current/80">·</span>
      <span>
        vs <span className="font-medium">{data.opponentName}</span>{' '}
        <span className="opacity-70">{data.opponentServer}</span>
      </span>
      {data.outcome && (
        <span
          className={cn(
            'ml-1 inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-medium',
            data.outcome === 'win'
              ? 'bg-emerald-900/50 text-emerald-200'
              : 'bg-red-900/50 text-red-200',
          )}
        >
          {data.outcome === 'win' ? <Trophy size={11} /> : <XCircle size={11} />}
          {data.outcome === 'win' ? 'Win' : 'Loss'}
        </span>
      )}
    </div>
  );
}
